import { render } from "./CountryPackageCard.vue?vue&type=template&id=65f99b04&ts=true"
import script from "./CountryPackageCard.vue?vue&type=script&lang=ts"
export * from "./CountryPackageCard.vue?vue&type=script&lang=ts"

import "./CountryPackageCard.vue?vue&type=style&index=0&id=65f99b04&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__